export default "__VITE_PUBLIC_ASSET__0f3666ac__"